
































































































import { PropType } from 'vue';
import { computed, defineComponent, ref, toRefs } from '@vue/composition-api';
import { cloneDeep } from 'lodash-es';
import treeNodeHoverEstimatePopover from '@/components/common/tree-node-hover-estimate-popover/index.vue';
import { useSimilarRecommend } from '../hooks/use-similar-recommend';
import { AdgroupFormData, CampaignFormData, NodeHoverContentType } from '@tt4b/ttam-enums';
export default defineComponent({
  name: 'SimilarRecommend',
  components: { treeNodeHoverEstimatePopover },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData } = toRefs(props);
    const {
      similarRecommendList: originSimilarRecommendList,
      isShowSimilarRecommend,
      similarRecommendTitle,
      selectOneSimilarRecommend,
      selectAllSimilarRecommend,
      subscribeSimilarRecommend,
    } = useSimilarRecommend({
      adgroupData,
      campaignData,
      emit,
    });

    subscribeSimilarRecommend();

    const similarRecommendList = computed(() => cloneDeep(originSimilarRecommendList.value));
    const isShowAllSimilarRecommend = ref(false);
    const similarRecommendTagsContainerRef = ref();
    const isShowAllBtnDisplay = computed(
      () => similarRecommendTagsContainerRef.value?.scrollHeight > similarRecommendTagsContainerRef.value?.offsetHeight,
    );

    // select中的id：`${scene}-${tag_id}`, 受众预估取id字段，但值为tag_id，
    function popoverOnShow(node) {
      node.id = node.tag_id;
    }

    function selectOneTag(tag, index) {
      selectOneSimilarRecommend(tag, index);
      emit('select-one', tag);
    }

    return {
      similarRecommendList,
      similarRecommendTagsContainerRef,
      isShowAllBtnDisplay,
      isShowAllSimilarRecommend,
      isShowSimilarRecommend,
      NodeHoverContentType,
      similarRecommendTitle,
      selectOneSimilarRecommend,
      selectAllSimilarRecommend,
      popoverOnShow,
      selectOneTag,
    };
  },
});
